/*@ngInject*/
const GridPagingController = function ($scope, $element, coreConstant) {

    let buttonWidth = 65,
        pageWidth = 35,
        summaryLength = 250,
        i;

    this.$onInit = function () {
        $element.addClass('gridPaging');

        this.showPaging = true;

        this.requestParams = {
            startIndex: this.startIndex,
            pageSize: this.pageSize
        };

        this.pages = [];
        this.maxVisiblePages = 10;
        this.startRecord = 1;
        this.endRecord = this.requestParams.pageSize;
        this.selectedPage = Math.ceil(this.requestParams.startIndex / this.requestParams.pageSize) + 1;



        for (i = 1; i < this.maxVisiblePages + 1; i++) {
            this.pages.push({number: i});
        }

        let totalWidth = 2 * buttonWidth + this.pages.length * pageWidth + summaryLength;
        this.totalWidth = {'width': totalWidth + 'px'};

        $scope.$on(coreConstant.event.DATAGRID_ON_RESET_HEADERS, function (evt, params) {
            this.onChange({
                params: {
                    pageSize: params.pageSize,
                    startIndex: params.startIndex
                }
            });
        }.bind(this));

        $scope.$on(coreConstant.event.RESET_GRID_PAGING, function (evt, pageSize, startIndex) {
            this.requestParams.startIndex = 0;
            if (startIndex) {
              this.requestParams.startIndex = startIndex;
            }
            if (pageSize) {
                this.requestParams.pageSize = pageSize;
            }
            this.startRecord = this.requestParams.startIndex + 1;
            this.selectedPage = Math.ceil(this.requestParams.startIndex / this.requestParams.pageSize) + 1;
            this.endRecord = this.startRecord + this.requestParams.pageSize - 1;
            this.notify();
        }.bind(this));

        $scope.$on(coreConstant.event.RECALCULATE_GRID_PAGING, function () {
            this.calculateVisiblePages();
        }.bind(this));

        this.calculateVisiblePages();

        this.$onChanges = function (changes) {
            this.calculateVisiblePages();
        };
    };

    this.numberClick = function (index) {
        let page = this.pages[ index ];
        if (this.selectedPage === page.number) {
            return;
        }

        //making sure that an empty page cannot be selected
        while ((page.number - 1) * this.requestParams.pageSize > this.totalRecords) {
            page.number--;
        }
        this.selectedPage = page.number;
        this.notify();
    };

    this.getMaxNumPages = function () {
        return Math.ceil(this.totalRecords / this.requestParams.pageSize);
    };

    this.changePage = function (direction) {
        let length = this.getMaxNumPages();
        if (this.selectedPage === length && direction === 1) {
            return;
        }

        if (this.selectedPage === 1 && direction === -1) {
            return;
        }

        this.selectedPage += direction;

        //define upper limit
        if (this.selectedPage > length) {
            this.selectedPage = length;
        }

        //define lower limit
        if (this.selectedPage < 1) {
            this.selectedPage = 1;
        }
        this.notify();
    };

    this.notify = function () {
        let requestParams = this.requestParams;
        requestParams.startIndex = (this.selectedPage - 1) * requestParams.pageSize;
        $scope.$emit(coreConstant.event.DATAGRID_ON_RESET_HEADERS, this.requestParams);
        this.startRecord = (this.selectedPage - 1) * (requestParams.pageSize) + 1;
        this.calculateVisiblePages();
    };

    this.calculateVisiblePages = function () {
        //updating visible pages in the pager
        let numOfGroups = Math.ceil(this.totalRecords / this.requestParams.pageSize),
            lower = 0,
            upper = 0,
            j;

        for (i = 0; i < numOfGroups; i++) {
            lower = i * this.maxVisiblePages;
            upper = i * this.maxVisiblePages + this.maxVisiblePages;
            if (this.selectedPage > lower && this.selectedPage <= upper) {
                this.pages = [];
                for (j = lower + 1; j < upper + 1 && j <= numOfGroups; j++) {
                    this.pages.push({number: j});
                }
                break;
            }
        }
        this.endRecord = this.selectedPage * this.requestParams.pageSize;
        //this is the case that the last page is not full
        if (this.endRecord > this.totalRecords) {
            this.endRecord = this.totalRecords;
        }
    };

    this.getRecordCountText = function () {
        let message = '';
        if (this.endRecord > 1) {
            message = this.recordsCountText;
        }
        else {
            message = this.recordCountText;
        }
        message = _.replace(message, 'startIndex', this.startRecord);
        message = _.replace(message, 'endIndex', this.endRecord);
        message = _.replace(message, 'total', this.totalRecords);
        return message;
    };
};

angular.module('umCore')
    .controller('gridPagingController', GridPagingController);
